import '../../styles/main/imageviewer.scss'

import { useState } from 'react'

// Language
import { useLanguage } from '../../context/language_context'


function ImageViewer({ images, projectName, closeViewer }) {

    const { language } = useLanguage()

    const [currentImage, setCurrentImage] = useState(0)


    const previousImage = () => {

        setCurrentImage((current) => {

            if (current === 0) {
                return images.length - 1
            }

            return current - 1

        })

    }


    const nextImage = () => {

        setCurrentImage((current) => {

            if (current === images.length - 1) {
                return 0
            }

            return current + 1

        })

    }


    return (

        <div className="image_viewer_overlay">

            <div className="image_viewer">

                {/* HEADER */}

                <div className="image_viewer_title">

                    <h3>
                        C:/Maurine_Duet/{projectName}/
                        {language === 'fr'
                            ? 'Galerie'
                            : 'Gallery'}
                    </h3>

                    <p
                        className="close_button"
                        onClick={closeViewer}
                    >
                        X
                    </p>

                </div>


                {/* IMAGE */}

                <div className="image_viewer_main">

                    <button
                        className="viewer_arrow"
                        onClick={previousImage}
                    >
                        &lt;
                    </button>


                    <img
                        src={images[currentImage]}
                        alt={`${projectName} - ${currentImage + 1}`}
                    />


                    <button
                        className="viewer_arrow"
                        onClick={nextImage}
                    >
                        &gt;
                    </button>

                </div>


                {/* FOOTER */}

                <div className="image_viewer_footer">

                    <p>
                        Image {currentImage + 1} / {images.length}
                    </p>

                </div>

            </div>

        </div>

    )

}

export default ImageViewer